import React from 'react';

export const ContactDetailsCircle = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="11" stroke="black" strokeWidth="1.5" />
    <path
      d="M18.25 20C18.25 20.4142 18.5858 20.75 19 20.75C19.4142 20.75 19.75 20.4142 19.75 20H18.25ZM4.25 20C4.25 20.4142 4.58579 20.75 5 20.75C5.41421 20.75 5.75 20.4142 5.75 20H4.25ZM19.75 20C19.75 15.7198 16.2802 12.25 12 12.25V13.75C15.4518 13.75 18.25 16.5482 18.25 20H19.75ZM12 12.25C7.71979 12.25 4.25 15.7198 4.25 20H5.75C5.75 16.5482 8.54822 13.75 12 13.75V12.25Z"
      fill="black"
    />
    <path
      clipRule="evenodd"
      d="M12 13C15 13 16 11.2091 16 9C16 6.79086 15 5 12 5C9 5 8 6.79086 8 9C8 11.2091 9 13 12 13Z"
      fill="white"
      fillRule="evenodd"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
